import { Component, inject, Input, signal, DestroyRef } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Product } from '../cart.model';
import { CartService } from '../cart.service';
import { ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
// import { ModalService } from '@ls-commons/utils/modals';
import { ProductIngredientsComponent } from '../product-ingredients/product-ingredients.component';

import _ from 'lodash';
import { ModalService } from 'libs/shared/utils/modals/src';

@Component({
  selector: 'app-product',
  standalone: true,
  imports: [CardModule, ButtonModule],
  providers: [ConfirmationService, DialogService, ModalService],
  templateUrl: './product.component.html',
  styleUrl: './product.component.scss',
})
export class ProductComponent {
  confirmationService = inject(ConfirmationService);
  dialogService = inject(DialogService);
  modalService = inject(ModalService);
  destroyRef = inject(DestroyRef);
  cartService = inject(CartService);
  quantity = signal(1);

  @Input() product!: Product;

  selectProductIngredients() {
    // console.log('opasa');

    // const ref =
    this.dialogService.open(ProductIngredientsComponent, {
      dismissableMask: true,
      header: 'Personalizar ingredientes',
      data: {
        product: _.cloneDeep(this.product),
      },
      width: '600px',
    });
    // ref.onClose.subscribe((reload: boolean) => {
    //   // reload && this.getProductTypes();
    // });
  }

  addToCart(product: Product) {
    this.cartService.addProduct(product!, 1);
  }
}
